import React, { useLayoutEffect, forwardRef, useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import useDarkMode from '../../hooks/useDarkMode';
import apiServicewt from '../../api/apiServicewt';

const PageWrapper = forwardRef(({ title, description, className, children }, ref) => {
	const { themeStatus } = useDarkMode();
	const [sname, setSname] = useState({});
	useEffect(() => {
		const fetchdata = async () => {
			const item = { action: 'get_login_settings' };
			const flechdata = await apiServicewt(item);
			if (flechdata.type === 'Success' || flechdata.type === 'success') {
				setSname(flechdata.data);
			}
		};
		fetchdata();
	}, []);

	useLayoutEffect(() => {
		document.getElementsByTagName('TITLE')[0].text = `${title ? `${title} | ` : ''}${
			// process.env.REACT_APP_SITE_NAME
			sname.company_name || 'Schedulerdesk'
		}`;
		document
			.querySelector('meta[name="description"]')
			.setAttribute('content', description || process.env.REACT_APP_META_DESC);
	});

	return (
		<div
			ref={ref}
			style={{
				backgroundColor:
					themeStatus === 'light' && title !== 'Login' && title !== 'Sign Up'
						? '#ececec'
						: undefined,
			}}
			className={classNames('page-wrapper', 'container-fluid', className)}>
			{children}
		</div>
	);
});
PageWrapper.propTypes = {
	title: PropTypes.string,
	description: PropTypes.string,
	children: PropTypes.node.isRequired,
	className: PropTypes.string,
};
PageWrapper.defaultProps = {
	title: null,
	description: null,
	className: null,
};

export default PageWrapper;
